export default {
  en: "English",
  de: "Deutsch",
  fr: "Français"
} as Record<string, string>;
